<template>
  <div class="near-match--row">
    <div
      class="is-flex"
      style="justify-content: space-between"
    >
      <div>
        <div class="has-text-left has-text-weight-bold">
          {{ matchedPerson.firstName }}
          {{ matchedPerson.lastName }}
        </div>
        <div class="has-text-grey has-text-left">
          {{ programName }}
        </div>
        <div class="has-text-grey has-text-left">
          Client Index ID: {{ clientIndexId }}
        </div>
      </div>
      <div v-if="nearMatch.matchType.code === 'DMALL'">
        <div>
          <img
            src="@/assets/state.png"
            alt="State Batch"
            style="width: 75%"
            title="State Batch"
          />
        </div>
        <div class="state-text">
          STATE BATCH
        </div>
      </div>
      <div class="is-flex flex-align--center">
        <router-link
          :to="{
            path: `/directMatch/compare/${nearMatch.id}`,
          }"
         >
          <font-awesome-icon
            :icon="['far', 'angle-double-right']"
            size="2x"
            title="View Details"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';

library.add(
  faAngleDoubleRight,
);

export default {
  props: {
    nearMatch: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('lookups', [
      'allPrograms',
    ]),
    clientIndexId() {
      return this.matchedPerson.uniqueidentifer ? this.matchedPerson.uniqueidentifer : 'N/A';
    },
    matchedPerson() {
      return this.nearMatch.dmMatchTransDetail.potentialMatch.matchedObject;
    },
    programName() {
      if (this.nearMatch.programCode) {
        return this.allPrograms.find(p => p.code === this.nearMatch.programCode).description;
      } return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
  .has-text-left
    font-size: 12px
    padding-left: 15px
    padding-top: 0.5rem
  .near-match--row
    border-bottom: 1px solid #eee
    padding: 0.5rem 1rem
  .state-text
    color: #6c757d
    font-size: 80%
    font-weight: 400
    width: 50px
</style>
